// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CaseDashboard Component Styles - Dedicated to avoid conflicts */

/* Loading Spinner */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #6c757d;
  /* Ensure no transformations are inherited or applied to the container */
  transform: none !important;
  border: none !important; /* Remove any unwanted borders */
  box-shadow: none !important; /* Remove any unwanted box-shadows */
}

.spinner {
  width: 40px !important;
  height: 40px !important;
  border: 4px solid #e1e5e9 !important;
  border-top: 4px solid #3498db !important;
  border-radius: 50% !important;
  animation: case-dashboard-spinner-spin 1s linear infinite !important; /* Ensure animation runs */
  animation-play-state: running !important; /* Explicitly ensure animation is running */
  margin-bottom: 16px;
  transform-origin: center center; /* Ensure rotation is from the center */
  box-sizing: border-box !important; /* Ensure padding and border are included in the element's total width and height */
  flex-shrink: 0 !important; /* Prevent the spinner from shrinking */
}

/* Ensure the text does not inherit any rotation */
.loading-spinner p {
  transform: none !important;
}

@keyframes case-dashboard-spinner-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Client info styling specifically for the cases table */
.cases-table .client-info {
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 0;
  padding: 0;
}

.cases-table .client-avatar {
  font-size: 1.2rem;
  flex-shrink: 0;
}

.cases-table .client-name {
  font-weight: 500 !important;
  color: #333 !important;
  font-size: 0.85rem !important;
  margin: 0;
  padding: 0;
  line-height: 1.2;
}

.cases-table .client-email {
  font-size: 0.75rem !important;
  color: #666 !important;
  margin: 0;
  padding: 0;
  line-height: 1.2;
}

/* Ensure the client info container is properly structured */
.cases-table td .client-info > div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}

/* Override any conflicting styles from other components */
.cases-table .client-info,
.cases-table .client-name,
.cases-table .client-email {
  /* Reset any inherited styles that might interfere */
  box-sizing: border-box;
  text-decoration: none;
  border: none;
  background: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/CaseDashboard.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,wEAAwE;EACxE,0BAA0B;EAC1B,uBAAuB,EAAE,gCAAgC;EACzD,2BAA2B,EAAE,oCAAoC;AACnE;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,6BAA6B;EAC7B,oEAAoE,EAAE,0BAA0B;EAChG,wCAAwC,EAAE,2CAA2C;EACrF,mBAAmB;EACnB,+BAA+B,EAAE,uCAAuC;EACxE,iCAAiC,EAAE,mFAAmF;EACtH,yBAAyB,EAAE,uCAAuC;AACpE;;AAEA,kDAAkD;AAClD;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,yDAAyD;AACzD;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,0DAA0D;AAC1D;;;EAGE,oDAAoD;EACpD,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["/* CaseDashboard Component Styles - Dedicated to avoid conflicts */\n\n/* Loading Spinner */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  color: #6c757d;\n  /* Ensure no transformations are inherited or applied to the container */\n  transform: none !important;\n  border: none !important; /* Remove any unwanted borders */\n  box-shadow: none !important; /* Remove any unwanted box-shadows */\n}\n\n.spinner {\n  width: 40px !important;\n  height: 40px !important;\n  border: 4px solid #e1e5e9 !important;\n  border-top: 4px solid #3498db !important;\n  border-radius: 50% !important;\n  animation: case-dashboard-spinner-spin 1s linear infinite !important; /* Ensure animation runs */\n  animation-play-state: running !important; /* Explicitly ensure animation is running */\n  margin-bottom: 16px;\n  transform-origin: center center; /* Ensure rotation is from the center */\n  box-sizing: border-box !important; /* Ensure padding and border are included in the element's total width and height */\n  flex-shrink: 0 !important; /* Prevent the spinner from shrinking */\n}\n\n/* Ensure the text does not inherit any rotation */\n.loading-spinner p {\n  transform: none !important;\n}\n\n@keyframes case-dashboard-spinner-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Client info styling specifically for the cases table */\n.cases-table .client-info {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n}\n\n.cases-table .client-avatar {\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.cases-table .client-name {\n  font-weight: 500 !important;\n  color: #333 !important;\n  font-size: 0.85rem !important;\n  margin: 0;\n  padding: 0;\n  line-height: 1.2;\n}\n\n.cases-table .client-email {\n  font-size: 0.75rem !important;\n  color: #666 !important;\n  margin: 0;\n  padding: 0;\n  line-height: 1.2;\n}\n\n/* Ensure the client info container is properly structured */\n.cases-table td .client-info > div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n}\n\n/* Override any conflicting styles from other components */\n.cases-table .client-info,\n.cases-table .client-name,\n.cases-table .client-email {\n  /* Reset any inherited styles that might interfere */\n  box-sizing: border-box;\n  text-decoration: none;\n  border: none;\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
